import Box from "@mui/material/Box"

import RecruitProfileDisplayField from "./RecruitProfileDisplayField"

/**
 * Two-column grid of label-above-value fields (single column on xs).
 *
 * @param {object} props
 * @param {Array<{ label: string, value: string, fullWidth?: boolean, asChips?: boolean }>} props.rows
 * @param {Array<string>} [props.fullWidthLabels] Span both columns for these labels.
 * @param {Array<string>} [props.chipLabels] Render matching labels as chip lists.
 */
export default function RecruitProfileDisplayFieldGrid({
  rows,
  fullWidthLabels = [],
  chipLabels = [],
}) {
  if (!rows?.length) {
    return null
  }

  const fullWidthSet = new Set(fullWidthLabels)
  const chipSet = new Set(chipLabels)

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        columnGap: 2.5,
        rowGap: 1.5,
        width: "100%",
        minWidth: 0,
      }}
    >
      {rows.map((row) => (
        <RecruitProfileDisplayField
          key={row.label}
          label={row.label}
          value={row.value}
          fullWidth={row.fullWidth ?? fullWidthSet.has(row.label)}
          asChips={row.asChips ?? chipSet.has(row.label)}
        />
      ))}
    </Box>
  )
}
